<div class="app-layout">
  <nz-tabset [(nzSelectedIndex)]="selectedTabIndex" (nzSelectedIndexChange)="navigateToTab($event)" class="tab-panel">
    <nz-tab [nzTitle]="titleFileUpload" *ngIf="!isNflAdmin">
      <ng-template #titleFileUpload>
        <span nz-icon nzType="upload" nzTheme="outline"></span>
        File Upload
      </ng-template>
    </nz-tab>
    <nz-tab [nzTitle]="uploadHistory">
      <ng-template #uploadHistory>
        <span nz-icon nzType="history" nzTheme="outline"></span>
        Upload History
      </ng-template>
    </nz-tab>
  </nz-tabset>

  <div class="tab-content">
    <router-outlet></router-outlet>
  </div>
</div>
